import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const CookiePolicyPage = () => {
  return (
    <>
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-32 pb-12 bg-brand-dark overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20clean%20minimal%20background%20texture%20light%20pattern%20professional%20website%20legal%20policy&width=1920&height=300&seq=cookie1&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative max-w-4xl mx-auto px-4 md:px-6 text-center">
            <div className="flex items-center justify-center gap-2 text-white/50 text-sm font-body mb-4">
              <Link to="/" className="hover:text-white transition-colors cursor-pointer">Home</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-white">Cookie Policy</span>
            </div>
            <h1 className="font-heading font-black text-white text-4xl md:text-5xl mb-3">Cookie Policy</h1>
            <p className="font-body text-white/60 text-sm">Last updated: April 6, 2026</p>
          </div>
        </section>

        {/* Content */}
        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="prose max-w-none font-body text-gray-600 text-sm leading-relaxed space-y-8">

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">What Are Cookies?</h2>
                <p>
                  Cookies are small text files that are placed on your computer or mobile device when you visit a website. They are widely used to make websites work more efficiently and to provide information to the website owners. Cookies help us remember your preferences and improve your overall experience on our site.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">How We Use Cookies</h2>
                <p className="mb-3">
                  Adry &amp; Mich Cleaning and Handyman Service uses cookies for the following purposes:
                </p>
                <ul className="list-disc pl-5 space-y-2">
                  <li><strong className="text-brand-dark">Essential Cookies:</strong> These cookies are necessary for the website to function properly. They enable core functionality such as page navigation and access to secure areas of the website.</li>
                  <li><strong className="text-brand-dark">Analytics Cookies:</strong> We use analytics tools to understand how visitors interact with our website. This helps us improve our content and services. The data collected is anonymous and aggregated.</li>
                  <li><strong className="text-brand-dark">Preference Cookies:</strong> These cookies allow our website to remember choices you make (such as your preferred language) and provide enhanced, more personalized features.</li>
                  <li><strong className="text-brand-dark">Marketing Cookies:</strong> These cookies may be set through our site by our advertising partners to build a profile of your interests and show you relevant ads on other sites.</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">Third-Party Cookies</h2>
                <p>
                  Some cookies on our website are placed by third-party services that appear on our pages. These may include:
                </p>
                <ul className="list-disc pl-5 space-y-2 mt-3">
                  <li><strong className="text-brand-dark">Google Maps:</strong> Used to display our location map. Google may set cookies to track usage.</li>
                  <li><strong className="text-brand-dark">ReputationHub:</strong> Used to display customer reviews widget. This service may set its own cookies.</li>
                  <li><strong className="text-brand-dark">Google Analytics:</strong> Used to analyze website traffic and user behavior anonymously.</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">How to Control Cookies</h2>
                <p className="mb-3">
                  You can control and manage cookies in several ways:
                </p>
                <ul className="list-disc pl-5 space-y-2">
                  <li><strong className="text-brand-dark">Browser Settings:</strong> Most browsers allow you to refuse or accept cookies, delete existing cookies, and set preferences for certain websites. Check your browser&apos;s help section for instructions.</li>
                  <li><strong className="text-brand-dark">Opt-Out Tools:</strong> You can opt out of Google Analytics by installing the <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" className="text-brand-green hover:underline cursor-pointer">Google Analytics Opt-out Browser Add-on</a>.</li>
                </ul>
                <p className="mt-3">
                  Please note that disabling certain cookies may affect the functionality of our website and your user experience.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">Cookie Retention</h2>
                <p>
                  Session cookies are temporary and are deleted when you close your browser. Persistent cookies remain on your device for a set period or until you delete them manually. The retention period varies depending on the type of cookie.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">Changes to This Policy</h2>
                <p>
                  We may update this Cookie Policy from time to time to reflect changes in technology, legislation, or our data practices. Any changes will be posted on this page with an updated revision date. We encourage you to review this policy periodically.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">Contact Us</h2>
                <p>
                  If you have any questions about our use of cookies, please contact us:
                </p>
                <div className="mt-3 bg-brand-beige rounded-2xl p-5 flex flex-col gap-2">
                  <p className="flex items-center gap-2 text-sm text-gray-600">
                    <i className="ri-mail-line text-brand-green"></i>
                    <a href="mailto:adrimich7778@hotmail.com" className="hover:text-brand-green transition-colors cursor-pointer">adrimich7778@hotmail.com</a>
                  </p>
                  <p className="flex items-center gap-2 text-sm text-gray-600">
                    <i className="ri-phone-line text-brand-green"></i>
                    <a href="tel:+15612626118" className="hover:text-brand-green transition-colors cursor-pointer">(561) 262-6118</a>
                  </p>
                  <p className="flex items-center gap-2 text-sm text-gray-600">
                    <i className="ri-map-pin-line text-brand-green"></i>
                    10639 Misty Ln, Royal Palm Beach, FL 33411
                  </p>
                </div>
              </div>

            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default CookiePolicyPage;
